// extracted by mini-css-extract-plugin
export default {"wrapper":"SubtractionLine_wrapper__WNxhU","withBorder":"SubtractionLine_withBorder__zFh1b","title":"SubtractionLine_title__GoZI1"};